export enum CustomerAgentStatus {
  Active = 1,
  Inactive = 2,
  Pending = 3,
  Deleted = 4,
}
